import { getCurrentScope, onScopeDispose } from 'vue'

const state = {
  count: 0,
  previousOverflow: null
}

function canLock() {
  return typeof document !== 'undefined' && !!document.body
}

function acquire() {
  if (!canLock()) return
  state.count += 1
  if (state.count > 1) return
  state.previousOverflow = document.body.style.overflow
  document.body.style.overflow = 'hidden'
}

function release() {
  if (!canLock()) return
  if (state.count === 0) return
  state.count -= 1
  if (state.count > 0) return
  document.body.style.overflow = state.previousOverflow ?? ''
  state.previousOverflow = null
}

export function scrollLockCount() {
  return state.count
}

export function resetScrollLock() {
  if (canLock() && state.count > 0) {
    document.body.style.overflow = state.previousOverflow ?? ''
  }
  state.count = 0
  state.previousOverflow = null
}

export function useScrollLock() {
  let holding = false

  const lock = () => {
    if (holding) return
    holding = true
    acquire()
  }

  const unlock = () => {
    if (!holding) return
    holding = false
    release()
  }

  if (getCurrentScope()) onScopeDispose(unlock)

  return {
    lock,
    unlock,
    isLocked: () => holding
  }
}
